import {
  KeywordDto,
  MaterialSelectorDto,
  MaterialSummaryDto,
} from '../services/APIs/InternalAPI/internal-api.contracts'

export interface MaterialSelector {
  selectableTokens: string[]
  selectedTokens: string[]
  materials: MaterialSummaryDto[]
  selectedMaterial: MaterialSummaryDto
  isActive: boolean
  isLoading: boolean
}

const MaterialsSorter = (materials: Array<MaterialSummaryDto>) => {
  const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base',
  })
  return materials.sort((a, b) => collator.compare(a.id, b.id))
}

export class MaterialSelectorUI {
  public selectableTokens: KeywordDto[]
  public selectedTokens: KeywordDto[]
  public materials: MaterialSummaryDto[]
  public selectedMaterial: MaterialSummaryDto

  public constructor(
    tokensAndMaterials: MaterialSelectorDto,
    selectedMaterial: MaterialSummaryDto
  ) {
    if (!tokensAndMaterials) return this

    const selectableTokens = Object.values(
      tokensAndMaterials.selectableTokens
    ).flat()

    const selectedTokens = Object.values(
      tokensAndMaterials.selectedTokens
    ).flat()

    return {
      selectableTokens: selectableTokens,
      selectedTokens: selectedTokens,
      materials: MaterialsSorter(tokensAndMaterials.materials),
      selectedMaterial: selectedMaterial,
    }
  }
}

// export class UIToken {
//   public label?: string
//   public value?: string

//   public constructor(tag: UIToken) {
//     return tag
//   }

//   public static fromStringArray(stringArray: string[]): UIToken[] {
//     return stringArray.map((x) => new UIToken({ label: x, value: x }))
//   }
// }

// export class Tokens {
//   public static fromTags(selectedTags: UIToken[]): Tokens {
//     const tokens: string[] = selectedTags.map((x) => x.value)

//     return new Tokens({
//       Tokens: tokens,
//     })
//   }

//   public Tokens: string[]

//   public constructor(tokens: Tokens) {
//     return tokens
//   }

//   public static parse(stringArray: string[]): Tokens {
//     return new Tokens({
//       Tokens: stringArray,
//     })
//   }
// }
